import { useEffect, useRef, useState, useCallback } from "react"
import "../styles/home.css"

/* ---------------- SLIDES DATA ---------------- */

const section1Slides = [
  { image: "/images/home.png" },
  { image: "/images/home1.png" },
  { image: "/images/home2.png" },
  { image: "/images/home3.png" },
  { image: "/images/home4.png" },
  { image: "/images/home5.png" },
  { image: "/images/home6.png" },
]

const section2Slides = [
  {
    lines: [
      "“Divya is very grounded person. I met Divya in one community program. She is highly intuitive and spiritual. I remember when we had first session and I opened up about so many things, she was so supportive. Since then she was always there. She has high knowledge of spiritual tools which actually works. After spiritual awakening, when I needed an ear to listen and validate what i am going through, God guided me to Divya. I am really grateful to have her. I did inner child healing with her and finally i am able to express my feelings through art, dance and journalling. She is highly empathetic and compassionate with strong boundaries.”",
      "Ritika, Pune",
    ],
  },
  {
    lines: [
      "“I met Divya by divine grace. When I first saw her in my office, something inside me told me, this girl is not an ordinary girl. She has divine powers. And that is how I came to know her. Talking to her a person is always left with a sense of calm, peacefulness, and happy state. I am not the same person I was before after taking her session, she connected me to God, power, divinity, peaceful and blissful state, which we will not get by material things. The one most important quality I like is her authenticity in spiritual practices. Not just routine custom, but real love for God. You can feel the authenticity by just talking to her for 15 minutes. Her beingness is calm, healing in nature. She is a very authentic healer, genuinely wants to make a real difference to people's life and that is her purpose.That itself speaks a lot of authenticity. I have not known anyone who met her, felt calm and peaceful. People like her are rare to find. Money can't buy such service. If you get her healing, you are blessed. Very authentic soul. Her healing sessions are authentic, truthful. You can trust her with your healing journey.”",
      "Ramadas, Bangalore",
    ],
  },
  {
    lines: [
      "“Having gone through a very bad time I was in a bad mental, spritual and emotional phase.i was introduced to Divya by one of my friend who wanted me to heal as he was getting healed and her healing helped him.Trusting my friend I took few sessions from Divya. In the first two sessions I saw a huge difference of relief. I never believed what I experienced. Over the time through ongoing sessions I felt my negativity reducing,I got charged up from inside. I got relief from mental worries, stress reduced, my emotions were handled well, spiritually I got closer to God.Divya is a calm, patient listener. Her calmness, her stillness is itself a relief. She doesn't rushes, she gives time, she believes healing takes time and also ensures it does through her healing. I really admire her strength, her work is impeccable and she is good in her work. Thank you Divya for showing me my dark side and making me walk towards light.”",
      "Malavika, Bangalore",
    ],
  },
  {
    lines: [
      "“She has transformed me into an entirely new person. Not only she healed me to the core, she has given me new pair of glasses to see the world with a different perspective. Such a divine power she embodies. I am fortunate to have met her.”",
      "Namrata, Bangalore",
    ],
  },
   {
    lines: [
      "“The session was very good and i am very  satisfied with attending the sessions. I am feeling more relaxed ,calm and better than before”",
      "Gurulakshmi, Bangalore",
    ],
  },
   {
    lines: [
      "“The guided meditations are peaceful. It enhances consciousness and improves day to day experiences.”",
      "Himanshi, New York",
    ],
  },
  {
    lines: [
      "“Divya, thank you so much for this session. I really appreciated how you explained everything before starting—the different layers like astral and causal, and the laws behind the healing. It helped me feel comfortable and trust the process. The session itself was much deeper than I expected, and I ended up breaking down emotionally, which is rare for me, but it felt like a much-needed release.What surprised me most was what happened afterward. Around 3–4 hours later, I could genuinely feel a shift, and the answers I had been seeking for a while started coming up naturally. I’ve completed two sessions so far and can already feel the difference. I’m grateful for this experience and really looking forward to continuing this healing journey with you 🤍 you have no idea how much this means to me 💙”",
      "Chaitrali, Hyderabad",
    ],
  },
  {
    lines: [
      "“My healing journey with Divya has been nothing short of truly wholesome and transformative. She is remarkable in her work, and her presence itself feels reassuring and deeply nurturing. Through her guided meditations, she gently leads you towards light, clarity, and inner peace and what’s beautiful is that it genuinely works. Each session feels like a sacred space where healing unfolds naturally.During my sessions, she didn’t only help me explore and heal past wounds, but also worked compassionately with the challenges I face in the present—many of which were rooted in those past experiences. Her approach feels complete and deeply aligned, addressing the soul at every level.Divya carries a divine energy, and I truly feel she is my guru, someone who continuously brings me closer to God and to my own higher self. Her voice is incredibly calming and refreshing, like a gentle embrace for the mind and heart. Her words feel like sacred spells, softly weaving their magic and healing every inch of the soul. Each session leaves me feeling lighter, more connected, and filled with gratitude.”",
      "Akansha, Mumbai",
    ],
  },
]

export default function Home() {
  const scrollRefs = useRef([null, null])
  const intervalRefs = useRef([null, null])
  const resumeTimeoutRefs = useRef([null, null])

  const [activeIndexes, setActiveIndexes] = useState([0, 0])

  /* ---------- STOP AUTO SCROLL ---------- */
  const stopAutoScroll = useCallback((sectionIndex) => {
    clearInterval(intervalRefs.current[sectionIndex])
    clearTimeout(resumeTimeoutRefs.current[sectionIndex])
    intervalRefs.current[sectionIndex] = null
    resumeTimeoutRefs.current[sectionIndex] = null
  }, [])

  /* ---------- SCROLL TO INDEX ---------- */
  const scrollToIndex = useCallback((sectionIndex, slideIndex) => {
    const container = scrollRefs.current[sectionIndex]
    if (!container) return

    const cards = container.querySelectorAll(".home-intro")
    const card = cards[slideIndex]
    if (!card) return

    setActiveIndexes((prev) => {
      const copy = [...prev]
      copy[sectionIndex] = slideIndex
      return copy
    })

    container.scrollTo({
      left:
        card.offsetLeft -
        (container.offsetWidth - card.offsetWidth) / 2,
      behavior: "smooth",
    })
  }, [])

  /* ---------- AUTO SCROLL ---------- */
  const startAutoScroll = useCallback(
    (sectionIndex, slidesLength) => {
      stopAutoScroll(sectionIndex)

      intervalRefs.current[sectionIndex] = setInterval(() => {
        setActiveIndexes((prev) => {
          const next = (prev[sectionIndex] + 1) % slidesLength
          scrollToIndex(sectionIndex, next)
          return prev.map((v, i) =>
            i === sectionIndex ? next : v
          )
        })
      }, 3000)
    },
    [scrollToIndex, stopAutoScroll]
  )

  /* ---------- SYNC DOTS ---------- */
  useEffect(() => {
    scrollRefs.current.forEach((container, sectionIndex) => {
      if (!container) return

      const onScroll = () => {
        const cards = container.querySelectorAll(".home-intro")
        const center =
          container.scrollLeft + container.offsetWidth / 2

        let closestIndex = 0
        let minDistance = Infinity

        cards.forEach((card, i) => {
          const cardCenter =
            card.offsetLeft + card.offsetWidth / 2
          const distance = Math.abs(center - cardCenter)
          if (distance < minDistance) {
            minDistance = distance
            closestIndex = i
          }
        })

        setActiveIndexes((prev) =>
          prev.map((v, i) =>
            i === sectionIndex ? closestIndex : v
          )
        )
      }

      container.addEventListener("scroll", onScroll, { passive: true })
      return () =>
        container.removeEventListener("scroll", onScroll)
    })
  }, [])

  /* ---------- INIT ---------- */
  useEffect(() => {
    startAutoScroll(0, section1Slides.length)
    startAutoScroll(1, section2Slides.length)

    return () => {
      stopAutoScroll(0)
      stopAutoScroll(1)
    }
  }, [startAutoScroll, stopAutoScroll])

  /* ---------- RENDER SECTION ---------- */
  const renderScrollSection = (slides, sectionIndex, pureImage = false) => (
    <>
      <section
        className={`home-horizontal-scroll ${
          pureImage ? "pure-image-section" : ""
        }`}
        ref={(el) => (scrollRefs.current[sectionIndex] = el)}
        onMouseEnter={() => stopAutoScroll(sectionIndex)}
        onMouseLeave={() => {
          resumeTimeoutRefs.current[sectionIndex] = setTimeout(
            () => startAutoScroll(sectionIndex, slides.length),
            3000
          )
        }}
      >
        <div className="home-scroll-track">
          {slides.map((slide, i) => (
            <div className="home-intro" key={i}>
              <div
                className={`home-container ${
                  pureImage ? "image-only" : "text-only"
                }`}
              >
                {slide.image && (
                  <div className="home-image">
                    <img src={slide.image} alt="" />
                  </div>
                )}

                {slide.lines && (
                  <div className="home-text">
                    {slide.lines.map((line, idx) => (
  <p
    key={idx}
    className={idx === 1 ? "testimonial-author" : ""}
  >
    {line}
  </p>
))}

                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </section>

      <div className="home-dots">
        {slides.map((_, i) => (
          <span
            key={i}
            className={`dot ${
              activeIndexes[sectionIndex] === i ? "active" : ""
            }`}
            onClick={() => scrollToIndex(sectionIndex, i)}
          />
        ))}
      </div>
    </>
  )

  return (
    <main className="home-root">
          {/* PURE IMAGE SLIDER */}
      {renderScrollSection(section1Slides, 0, true)}

    <section className="home-middle-image">
  <img
    src="/images/intro1.png"
    alt="Free Intro Session"
    className="home-middle-bg"
  />
<a
  href="https://wa.me/917396502963?text=Hello%20Divya%0A%0AI%E2%80%99d%20like%20to%20book%20the%20Free%20Intro%20Session%20mentioned%20on%20your%20website.%0APlease%20let%20me%20know%20the%20next%20steps.%0A%0AThank%20you"
  target="_blank"
  rel="noopener noreferrer"
  className="whatsapp-sticker"
>
  <img
    src="/images/join_now.png"
    alt="Chat on WhatsApp"
  />
</a>

</section>

<section className="testimonial-heading">
  <img
    src="/images/heart_star_left.png"
    alt="Left sticker"
    className="heading-sticker"
  />

  <h1 className="testimonial-title">Whispers of the Soul</h1>

  <img
    src="/images/heart_star_right.png"
    alt="Right sticker"
    className="heading-sticker"
  />
</section>

      {/* TESTIMONIAL SLIDER */}
      {renderScrollSection(section2Slides, 1)}
    </main>
  )
}
